import GenericFilter from '@/AdminComponent/GenericFilter';
import { ROLE_OPTIONS, STATUS_OPTIONS, SORT_OPTIONS } from '../utils/constants';

const APPROVAL_CONFIG = [
  {
    type: 'select',
    name: 'role',
    label: 'Role Filter',
    options: ROLE_OPTIONS, 
    grid: { xs: 12, sm: 6, md: 2 },
  },
  {
    type: 'select',
    name: 'status',
    label: 'Status Filter',
    options: STATUS_OPTIONS, 
    grid: { xs: 12, sm: 6, md: 2 },
  },
  {
    type: 'select',
    name: 'sort',
    label: 'Sort By',
    options: SORT_OPTIONS,
    grid: { xs: 12, sm: 6, md: 2.5 },
  },
  {
    type: 'text',
    name: 'search',
    label: 'Search Name or Email',
    placeholder: 'Enter name or email...',
    grid: { xs: 12, sm: 6, md: 3.5 },
  },
];

const ApprovalFilters = ({ filters, setFilters }) => {
  return (
    <GenericFilter
      config={APPROVAL_CONFIG}
      filters={filters}
      setFilters={setFilters}
      debounceMs={500}
      syncWithUrl
      showReset
    />
  );
};

export default ApprovalFilters;
